import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { EditableTextComponent } from '../../../base/text/editable-text/editable-text.component';
import { BaseComponent } from '../../base/base.component';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';

@Component({
  selector: 'app-base-faq-item',
  imports: [
    CommonModule,
    EditableTextComponent,
    MatIconModule,
    MatExpansionModule,
  ],
  templateUrl: './base-faq-item.component.html',
  styleUrl: './base-faq-item.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BaseFaqItemComponent extends BaseComponent {
  // public readonly showElement = input.required<"question" | "answer" | "both">();

  // public textExpanded: boolean = false;

  override labelMap = {
    question: 'question',
    answer: 'answer',
  };

  
}
